import actions from "./ahliCalculator.actions";

export const initialState = {
  ahliLoanDetails: undefined,
};

export default function AhliCalculatorReducer(state, action) {
  switch (action.type) {
    case actions.STORE_AHLI_LOAN_DETAILS:
      return {
        ...state,
        ahliLoanDetails: { ...action.payload },
      };
    default:
      throw new Error("Unsupported action type at fav listings reducer");
  }
}
